import { Button } from "./Button";
import { gsap, Power4 } from "gsap";
import { ClampToEdgeWrapping } from 'three';
import {
    vDefaultShader as vertexShader,
    fSoundButtonShader as fragmentShader
} from '../shaders/';

export class SoundButton extends Button {

    // Add the custom soundOn value
    getUniforms() {
        return {
            ...super.getUniforms(),
            soundOn: { value: 1 },
        }
    }

    getMap() {
        const map = this.assets.textures[this.textureIds[0]];
        map.wrapS = ClampToEdgeWrapping;
        map.wrapT = ClampToEdgeWrapping;

        return {
            map: { value: map },
        }
    }

    getShaders() {
        return {
            fragmentShader,
            vertexShader,
        }
    }

    setMuted(muted) {
        gsap.to(this.material.uniforms.soundOn, {
            value: muted ? 0 : 1,
            duration: 2,
            ease: Power4.easeOut,
        });
    }
}